import { Injectable } from '@angular/core';
import { CreditCardType } from '@platform-frontend/payment-util';
import { InvalidStateError } from '@platform-frontend/util';
import { GooglePayPaymentData } from './model/google-pay-payment-data';

@Injectable({
  providedIn: 'root'
})
export class WalletPaymentDataService {
  mapGooglePayPaymentDataToCreditCardType(paymentData: GooglePayPaymentData): CreditCardType {
    const info = paymentData.paymentData.paymentMethodData.info;
    if (!info) {
      throw new InvalidStateError('Google Pay payment method info is missing');
    }
    switch (info.cardNetwork) {
      case 'AMEX':
        return 'AmericanExpress';
      case 'DISCOVER':
        return 'Discover';
      case 'ELECTRON':
      case 'ELO':
      case 'ELO_DEBIT':
      case 'VISA':
        return 'Visa';
      case 'JCB':
        return 'JCB';
      case 'MAESTRO':
      case 'MASTERCARD':
      case 'INTERAC':
        return 'MasterCard';
      default:
        throw new InvalidStateError(`Unknown card network: ${info.cardNetwork}`);
    }
  }
}
